<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Planday - Portal - Employees</h2>

    <vs-table
      v-if="portal"
      ref="table"
      class="mt-8"
      v-model="selected"
      :data="portal.employees"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
      </div>

      <template slot="thead">
        <vs-th sort-key="name">User</vs-th>
        <vs-th sort-key="city">Address</vs-th>
        <vs-th>Employee Groups</vs-th>
        <vs-th sort-key="id">Planday ID</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ tr.firstName }} {{ tr.lastName }}</p>
              <p class="product-name">{{ tr.email }}</p>
              <p class="product-name">{{ tr.phone }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name">{{ tr.street1 }}</p>
              <p class="product-name">{{ tr.zip }} {{ tr.city }}</p>
            </vs-td>

            <vs-td>
              <vs-chip v-for="(employeeGroup, index) in tr.employeeGroups" :key="index" :color="employeeGroup.isPosition ? 'success' : ''">
                {{ employeeGroup.name }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.id }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      portal: null,
      selected: null
    };
  },
  methods: {
    getPortal: function (portalId) {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/planday/' + portalId)
          .then(resp => {
            this.portal = resp.data

            console.log(this.portal);
          })
          .catch(err => {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch portal:' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  created() {
    this.getPortal(this.$route.params.portalId);
  }
};
</script>